module.exports = {
  __depends__: [ require(42) ],
  __init__: [ 'canvas' ],
  canvas: [ 'type', require(33) ],
  elementRegistry: [ 'type', require(35) ],
  elementFactory: [ 'type', require(34) ],
  eventBus: [ 'type', require(36) ],
  graphicsFactory: [ 'type', require(37) ]
};